// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bbh_a bhh_g"};